import { createAction } from '../../../store.model';
import { PerformerHistoryDto } from '../../core';
import { TrendDialogMode } from '../../trend-dialog';
import { ActionType } from '../main.action';

export interface ShowTrendDialog {
    mode: TrendDialogMode;
    managerId: number;
    userId: number;
}

export const showTrendDialog = createAction<ActionType, ShowTrendDialog>(
    ActionType.MI2_MAIN__SHOW_TREND_DIALOG,
);

export interface ShowTrendDialogResult extends ShowTrendDialog {
    data?: PerformerHistoryDto;
}

export const showTrendDialogResult = createAction<
    ActionType,
    ShowTrendDialogResult
>(ActionType.MI2_MAIN__SHOW_TREND_DIALOG_RESULT);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface HideTrendDialog {}

export const hideTrendDialog = createAction<ActionType, HideTrendDialog>(
    ActionType.MI2_MAIN__HIDE_TREND_DIALOG,
);
